import { render, staticRenderFns } from "./StandCard.vue?vue&type=template&id=54973fe5&"
import script from "./StandCard.vue?vue&type=script&lang=js&"
export * from "./StandCard.vue?vue&type=script&lang=js&"
import style0 from "./StandCard.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports